import { fetchFromObject } from 'helpers/object';

export default {
  dataWebsite: state => field => fetchFromObject(state, field)
};
